const videoTypes = {
    ORION: 'ORION',
    INVENIET: 'INVENIET'
}

export default videoTypes;